'use client'

import dynamic from 'next/dynamic'

import { Skeleton } from '@/components/ui/skeleton'

const ChartSkeleton = () => <Skeleton className="size-full min-h-80 rounded-xl" />

// Code-split so chart.js/react-chartjs-2 stay out of the tracker's initial bundle.
const ChartStatus = dynamic(() => import('./ChartStatus').then((m) => m.ChartStatus), {
  ssr: false,
  loading: ChartSkeleton,
})

const ChartTopic = dynamic(() => import('./ChartTopic').then((m) => m.ChartTopic), {
  ssr: false,
  loading: ChartSkeleton,
})

/**
 * Displays bills stats in charts.
 * Both charts use allFilteredBills from context so they reflect the current scope.
 */
export const BillStats = () => {
  return (
    <div>
      <div className="wrapper grid min-h-[686px] grid-cols-1 gap-5 lg:grid-cols-[2fr_3fr]">
        {/* Bar Chart */}
        <ChartStatus />

        {/* Doughnut Chart */}
        <ChartTopic />
      </div>
    </div>
  )
}
